// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_fx","advertDetailServiceList__header":"c-p_fy","advertDetailServiceList__list":"c-p_fz"};